export default "__VITE_ASSET__729573fd__"